import { LastTransaction } from "@/types/api/merchant/merchant.type";
import useThousandsSeparator from "@/hooks/useThousandsSeparator";
import CustomTable from "@/shared/components/common/table";
import CustomButton from "@/shared/components/kit/button";
import CardKit from "@/shared/components/kit/card";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import moment from "jalali-moment";
/**

TransactionGiftCharge
نمایش آخرین تراکنش شارژ هدیه کاربر به همراه اطلاعات جزئیات و ایجاد تراکنش جدید.
کامپوننت به صورت واکنش‌گرا طراحی شده و شامل جدول، دکمه‌ها و وضعیت خالی است.
@param {Object} props
@param {LastTransaction | undefined} props.dataUser - اطلاعات آخرین تراکنش کاربر
@returns JSX.Element
ساختار:
CardKit: کارت اصلی حاوی محتوا
StackKit: مدیریت چینش عمودی و افقی اجزاء
TypoGraphyKit: متن‌ها
CustomButton: دکمه‌های عملیات (جزئیات و هدیه جدید)
CustomTable: نمایش داده‌های جدول تراکنش
وضعیت خالی جدول در صورت عدم وجود داده
ویژگی‌های واکنش‌گرایی:
دکمه‌ها در موبایل به صورت عمودی نمایش داده می‌شوند
جدول دارای اسکرول افقی در نمایشگرهای کوچک است
*/
const TransactionGiftCharge = ({dataUser,}: {dataUser: LastTransaction | undefined;}) => {

  const numberSeparator = useThousandsSeparator;

  const dataHeader = [
    { id: "rowId", title: "شناسه" },
    { id: "gift", title: "مبلغ هدیه ( ریال)" },
    { id: "type", title: "مدت استفاده" },
    { id: "created_at", title: "پایان اعتبار" },
    { id: "description", title: "توضیحات" },
  ];

  const dataBodyTable = [
    {
      rowId: dataUser?.ref ? dataUser?.ref : "-",
      gift: dataUser?.gift ? numberSeparator(`${dataUser?.gift}`) : "-",
      type: "-",
      created_at: dataUser?.created_at ? moment(dataUser?.created_at).locale("fa").format("YYYY-MM-DD") : "-",
      description: dataUser?.description ? dataUser?.description : "-",
    },
  ];

  const fakeData: any = dataBodyTable;

  return (
    <CardKit sx={{ bgcolor: "#2C2C2C" }}>
      <StackKit sx={{ width: "100%" }} gap={2}>
        {/* Header & Buttons */}
        <StackKit direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems={{ xs: "flex-start", sm: "center" }} gap={2}>
          <TypoGraphyKit variant="body1">
            آخرین تراکنش شارژ هدیه
          </TypoGraphyKit>

          <StackKit direction={{ xs: "column", sm: "row" }} gap={2} width={{ xs: "100%", sm: "auto" }}>
            <CustomButton sx={{ width: { xs: "100%", sm: "auto" }, bgcolor: "gray" }}>
              <TypoGraphyKit variant="body1">جزئیات</TypoGraphyKit>
            </CustomButton>
            <CustomButton sx={{ width: { xs: "100%", sm: "auto" } }}>
              <TypoGraphyKit variant="body1">هدیه جدید</TypoGraphyKit>
            </CustomButton>
          </StackKit>
        </StackKit>

        {/* Table */}
        <div style={{ overflowX: "auto" }}>
          <CustomTable dataHeader={dataHeader} dataTbody={fakeData} />
        </div>

        {/* Empty State */}
        {fakeData.length === 0 && (
          <StackKit sx={{width: "100%",bgcolor: "#323232",borderRadius: "8px",height: "50px",}} justifyContent="center" alignItems="center">
            <TypoGraphyKit variant="body1">دیتایی وجود ندارد</TypoGraphyKit>
          </StackKit>
        )}
      </StackKit>
    </CardKit>
  );
};

export default TransactionGiftCharge;
